/**
 * TOML Minify Tool
 *
 * Minify TOML by parsing and re-stringifying with blank lines removed.
 */

import { parse as parseToml, stringify as stringifyToml } from 'smol-toml';

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import { ToolError } from '@/engine/errors/ToolError';
import type { ITransformerTool } from '@/interfaces/ITool';

export const TomlMinifyTool: ITransformerTool = {
  id: 'toml-minify',
  name: 'TOML Minify',
  description: 'Minify TOML by removing comments and blank lines',
  version: '1.0.0',
  type: 'transformer',
  category: 'Formatters & Minifiers',
  keywords: ['toml', 'minify', 'compress', 'compact'],

  seo: {
    slug: 'toml-minifier',
    pageTitle: 'TOML Minifier - Free Online Tool | Prism',
    metaDescription: 'Minify TOML files by stripping comments and blank lines. Reduce file size while keeping valid TOML. Fast, private, runs in your browser.',
    keywords: ['toml minifier', 'minify toml online', 'toml compress', 'toml compact', 'toml strip comments'],
    relatedTools: ['toml-format', 'toml-validate', 'toml-to-json'],
    schemaType: 'WebApplication',
  },

  supportedInputTypes: [SEMANTIC_TYPES.TEXT],
  outputType: SEMANTIC_TYPES.TEXT,

  attributes: [],

  async transform(input: string): Promise<string> {
    const text = String(input ?? '').trim();
    if (!text) return '';

    try {
      const parsed = parseToml(text);
      const output = stringifyToml(parsed as Record<string, unknown>);
      // Strip blank lines for compact output
      return output
        .split('\n')
        .filter(line => line.trim() !== '')
        .join('\n')
        .trimEnd();
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Failed to minify TOML';
      throw ToolError.execution(message);
    }
  },
};
